import { useDispatch, useSelector } from "react-redux";
import { partnerActiveSelector } from "../../Reducers/partnerActiveReducer";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useEffect } from "react";
import { logout } from "../../Actions/loginAction";

const PartnerWelcomeWrapper = () => {
  const partnerActive = useSelector(partnerActiveSelector)
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
      if (partnerActive !== null) {
          if (!partnerActive.active)
              history.push("/partner-portal/welcome");
      }
  }, [partnerActive, history])

  return (
      <div className="d-flex justify-content-center align-items-center vh-100 bg-white">
        <div className="text-center text-muted">
          <p className="h3 mb-3" style={{maxWidth: "600px"}}>
            Thanks for signing up! We will call and/or email you to verify your account. Hang tight!
          </p>
          <button
            onClick={() => dispatch(logout())}
            className="btn login-btn login-primary-btn"
          >
            Go back
          </button>
        </div>
      </div>
    );
}
export default PartnerWelcomeWrapper